<template>
    <div class="bg_F9F8F7">
        <nav-bar />
        <div>
            <div class="top_bar bg_img">

            </div>
            <div class="bread_crumb w_1500">
                当前位置：首页 > 关于我们 > 详情
            </div>
            <div class="transaction_list bg_fff_box w_1500">
                <div class="w_1280">
                    <div class="address_coordinates">
                        <baidu-map class="bm-view" :zoom="12" :center="{ lng: 108.061, lat: 32.064 }">
                            <bm-marker :position="{ lng: 108.061, lat: 32.064 }" :icon="customIcon" draggable="false">
                                <!-- 自定义图标 -->
                                <bm-label :content="'万源市农村产权（茶园）交易大数据中心'"
                                    :labelStyle="{ color: '#000000', fontSize: '24px', border: 'none', background: 'none' }"
                                    :offset="{ width: -205, height: 50 }" />
                            </bm-marker>
                        </baidu-map>
                    </div>

                    <div>
                        <div class="about_us_info">万源市农村产权（茶园）交易大数据中心</div>
                        <div class="about_us_info">地址:万源市石塘镇双合村</div>
                        <div class="about_us_title">联系电话</div>
                        <div class="about_us_info">报名咨询:0532-88315577</div>
                        <div class="about_us_info">监督举报电话:13225328000</div>
                        <div class="about_us_info">市农村产权交易监督委员会办公室:0532-8831</div>
                    </div>
                </div>
            </div>
        </div>
        <bottom-bar></bottom-bar>
    </div>
</template>

<script>
import newIcon3 from '@/assets/images/newIcon3.png'
// @ is an alias to /src

export default {
    components: {
    },
    data() {
        return {
            customIcon: {
                url: require('@/assets/images/newIcon3.png'),  // 根据实际图片路径调整此处
                size: { width: 150, height: 100 },  // 图标尺寸，可按需调整
            }
        }
    },
    mounted() {
    },
    methods: {

    }
}
</script>

<style scoped lang="scss">
.bg_img {
    // background: url("@/assets/images/banner6.png") center no-repeat;
    background-size: cover;
}

.transaction_list {
    padding-top: 80px;
    padding-bottom: 85px;
    margin-bottom: 193px;
}

.address_coordinates {
    height: 700px;
    margin-bottom: 60px;
}

.bm-view {
    width: 100%;
    height: 700px;
}

.about_us_title {
    font-size: 36px;
    font-weight: 600;
    color: #313131;
    margin-top: 60px;
}

.about_us_info {
    font-size: 30px;
    color: #313131;
    margin-top: 10px;
}
</style>